export const codeReactInstall = `yarn add react@^18.2.0 react-dom@^18.2.0
yarn add --dev @types/react@^18.2.0 @types/react-dom@^18.2.0 typescript@~5.4.0`;

export const codeAtlaskitInstall = `yarn add @atlaskit/css-reset @atlaskit/tokens`;

export const codeCSSResetImport = `import '@atlaskit/css-reset';`;

export const codeBabelInstall = `yarn add @atlaskit/tokens
yarn add --dev @compiled/babel-plugin @compiled/babel-plugin-strip-runtime`;

export const codeBabelSetup = `// babel.config.js
module.exports = {
  plugins: [
    '@atlaskit/tokens/babel-plugin',
    // ↓↓ Compiled should run last ↓↓
    ['@compiled/babel-plugin', { transformerBabelPlugins: ['@atlaskit/tokens/babel-plugin'] }],
    // OPTIONAL: If you are distributing your own packages with Compiled styles (eg. to NPM/etc), you want to convert runtime Compiled to distribute \`compiled.css\` files for consumers to load:
    [
      '@compiled/babel-plugin-strip-runtime',
      {
        sortShorthand: true,
        // Your \`extractStylesToDirectory\` config is relative to where you build your output distributions for NPM/etc
        extractStylesToDirectory: { source: 'src', dest: 'dist' }
      },
    ],
  ],
};`;

export const codeParcelInstall = `yarn add @atlaskit/tokens
yarn add --dev @compiled/parcel-config`;

export const codeParcelCompiledSetup = `// .compiledcssrc
{
  "transformerBabelPlugins": [["@atlaskit/tokens/babel-plugin"]],
  "extract": true,
  "inlineCss": true,
  "sortShorthand": true
}`;

export const codeParcelRcSetup = `// .parcelrc
{
  "extends": ["@parcel/config-default", "@compiled/parcel-config"]
}`;

export const codeWebpackInstall = `yarn add @atlaskit/tokens
yarn add --dev @compiled/webpack-loader mini-css-extract-plugin`;

export const codeWebpackSetup = `// webpack.config.js
const { CompiledExtractPlugin } = require('@compiled/webpack-loader');
const MiniCssExtractPlugin = require('mini-css-extract-plugin');
module.exports = {
  module: {
    rules: [
      {
        test: /\.(js|jsx|ts|tsx)$/,
        use: [
          { loader: 'babel-loader' },
          {
            // ↓↓ Compiled should run last ↓↓
            loader: '@compiled/webpack-loader',
            options: {
              transformerBabelPlugins: ['@atlaskit/tokens/babel-plugin'],
              extract: true,
              inlineCss: true,
            },
          },
        ],
      },
      {
        test: /compiled(-css)?\.css$/i,
        use: [MiniCssExtractPlugin.loader, 'css-loader'],
      },
      {
        test: /(?<!compiled-css)(?<!\.compiled)\.css$/,
        use: ['style-loader', 'css-loader'],
      },
    ],
  },
  plugins: [
    new MiniCssExtractPlugin({
      // This is a common configure to ensure this is a unique file between builds
      filename: '[name].[contenthash].css',
    }),
    new CompiledExtractPlugin({ sortShorthand: true }),
  ],
};`;

export const codeESLintInstall = `yarn add --dev @atlaskit/eslint-plugin-design-system`;

export const codeESLintSetup = `module.exports = {
  plugins: [
    '@atlaskit/design-system',
  ],
  extends: [
    'plugin:@atlaskit/design-system/recommended',
  ],
};`;

export const codeButtonInstall = `yarn add @atlaskit/button`;

export const codeButtonUsage = `import Button from '@atlaskit/button';
const App = () => <Button>Hello world</Button>;`;
